import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/components/shared/page-header'
import { ModerationTable } from '@/components/social-listening/moderation-table'

export const Route = createFileRoute('/_app/creators/moderacao')({
  component: ModeracaoPage,
})

function ModeracaoPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Moderação"
        description="Gerencie comentários nos posts do Instagram da sua marca."
      />
      <ModerationTable />
    </div>
  )
}
